module.exports = __webpack_public_path__ + "img/Rapid7-Nexpose.bbbc9ea.svg";